/*
 * Algemene voorwaarden.
 *
 * Deze pagina bestaat niet op legacy/current — er is dus geen bestaande tekst om
 * over te nemen. Hij staat er wel omdat FR-23 en de acceptatie-eisen van Mollie
 * (R-07) hem vragen, en omdat de footer ernaar verwijst. De tekst komt uit O-05,
 * het annulerings- en restitutiebeleid uit O-04.
 *
 * De opbouw volgt de privacyverklaring, zodat de definitieve tekst er zonder
 * vormgevingswerk in kan.
 */
export default function Voorwaarden() {
  return (
    <>
      <div className="page-head">
        <div className="wrap">
          <span className="eyebrow">Voorwaarden</span>
          <h1>Algemene voorwaarden</h1>
          <p className="lede">
            Deze pagina wordt nog opgesteld. De algemene voorwaarden worden
            juridisch opgesteld en gereviewd (zie requirements O-05).
          </p>
        </div>
      </div>
      <section className="section" style={{ paddingTop: '36px' }}>
        <div className="wrap">
          <div className="prose">
            <p data-plaatshouder="O-05">
              In de definitieve voorwaarden worden onder meer benoemd: wat de
              beoordeling inhoudt, wat u van ons mag verwachten, de tarieven en
              de betaling, en het annulerings- en restitutiebeleid (O-04).
            </p>
          </div>
        </div>
      </section>
    </>
  )
}
